import fileSaver from 'file-saver';
import moment from 'moment';
import isServer from './isServer';
import * as fetcher from '@hydra/utils/fetcher';

async function sendFileToUserBrowser (name, pdfBlob) {
  if (isServer()) {
    throw new Error('Cannot save PDF file on server');
  }
  return fileSaver.saveAs(pdfBlob, name);
}

export const getPdfFileName = (url) => {
  const date = moment().format('Y-M-D HH:mm:ss');
  const type = 'review';
  const host = url.replace('.', '-');
  return `${type}_${host}_${date}.pdf`;
};

export async function pdfDownload ({ url, templateId = 'default', pdfEditorLimited, userId = null }) {
  const name = getPdfFileName(url);
  const searchParams = {
    templateId,
    client: 'front',
    name,
    pdfEditorLimited: pdfEditorLimited ? '1' : '0',
    ...(userId ? { userId } : {})
  };

  const uri = `/api/pdf-download${userId ? '-user' : ''}/${encodeURIComponent(url)}`;
  const pdf = await fetcher.get(uri, { searchParams }).blob();
  return sendFileToUserBrowser(name, pdf);
}
